module.exports = __webpack_public_path__ + "img/4.4ca4d82a.jpg";